import "./App.css";

import { createClient } from "@supabase/supabase-js";
import { useState } from "react";

function passwordStatus(password, confirmedPassword) {
  if (password !== confirmedPassword) {
    return "Passwords don't match";
  } else if (password.length < 8) {
    return "Password too short";
  } else {
    return "Passwords match";
  }
}

async function createAccount(
  email,
  password,
  confirmedPassword,
  supabase,
  setErrorMessage,
  setCreated
) {
  let status = passwordStatus(password, confirmedPassword);
  if (status === "Passwords match") {
    setErrorMessage("");
    try {
      let res = await supabase.auth.signUp({
        email: email,
        password: password,
      });
      console.log(res);
      if (res.error) {
        setErrorMessage(res.error.message);
        return;
      }
      if (res.data.user.id) {
        setCreated(true);
      }
    } catch (e) {
      setErrorMessage(e.message);
      console.error("Couldn't create account:", e);
    }
  } else {
    setErrorMessage(status);
  }
}

function App() {
  const supabaseUrl = "https://tfcrcoqvdowylhfnnnzo.supabase.co";
  const supabaseKey = "sb_publishable_W7KrCGJ-B2L3Jai0JZy-2Q_gD2SkfTl";
  const supabase = createClient(supabaseUrl, supabaseKey);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [created, setCreated] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        {!created ? (
          <>
            <label className="signup-cluster">Email:</label>
            <input
              className="signup-cluster"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label className="signup-cluster">Password:</label>
            <input
              className="signup-cluster"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="signup-cluster">Confirm Password:</label>
            <input
              className="signup-cluster"
              type="password"
              value={confirmedPassword}
              onChange={(e) => setConfirmedPassword(e.target.value)}
            />
            <label className="signup-cluster">
              {passwordStatus(password, confirmedPassword)}
            </label>
            <div
              id="signup"
              onClick={() =>
                createAccount(
                  email,
                  password,
                  confirmedPassword,
                  supabase,
                  setErrorMessage,
                  setCreated
                )
              }
            >
              Submit
            </div>
            <div id="error">{errorMessage}</div>
            <p>
              Already have an account?{" "}
              <a href="https://www.entangledtabs.com">sign in now!</a>
            </p>
          </>
        ) : (
          <label>
            Account Created! Check your email for a confirmation link. Login to
            the Entangled extension or visit{" "}
            <a href="https://www.entangledtabs.com">entangledtabs.com</a>
          </label>
        )}
      </header>
    </div>
  );
}

export default App;
